import React from "react";
import "./css/divisorLine.css";

const DivisorLine = ({ lineSecond = true }) => {
  return (
    <div className="d-flex flex-column my-5">
      <div className="flex-grow-1 border-top line-hv  ms-5 me-5"></div>
      {lineSecond && (
        <div className="flex-grow-1 border-top line-hv line-hv-padding "></div>
      )}
    </div>
  );
};

export default DivisorLine;
